import BaseModal from './BaseModal';
import s from './BaseModal.module.css';
import l from './LoginModal.module.css';
import { useHistory } from 'react-router-dom';
import { formatWithCommas } from 'functions/fields';

const UpgradeModal = ({lastAttemptedAdd, contactsCurrentPeriod, contactLimit, onClose}) => {
    const history = useHistory();
    const goToUpgrade = () => {
        // Redirect to login page
        history.push('/upgrade');
    }
    return ( 
        <BaseModal height="20rem" onClose={onClose}>
            <div className={l.loginModalContainer}>
                <div className={l.title}>
                    Need more contacts?
                </div>
                <div className={l.subtitle}>
                    You've saved {formatWithCommas(contactsCurrentPeriod)} new contacts this period. <br />Adding {formatWithCommas(lastAttemptedAdd)} more would exceed your limit of {formatWithCommas(contactLimit)}.
                </div>
                <div className={`${s.blackButton} ${l.button}`} onClick={goToUpgrade}>OK, Let's Upgrade</div>
            </div>
        </BaseModal>
     );
}
 
export default UpgradeModal;